import Warning from './Warning';
import Error from './Error';
import Success from './Success';
import Info from './Info';
import Neutral from './Neutral';
import Brand from './Brand';
import Overlay from './Overlay';

export default {
  Warning,
  Error,
  Success,
  Info,
  Neutral,
  Brand,
  Overlay,
};

export const WarningBadge = Warning;
export const ErrorBadge = Error;
export const SuccessBadge = Success;
export const InfoBadge = Info;
export const NeutralBadge = Neutral;
export const BrandBadge = Brand;
export const OverlayBadge = Overlay;
